module.exports = __webpack_public_path__ + "static/media/trash.35ddddce.svg";